<template>
  <div class="support" :style="{ 'min-height': clientHeight + 'px' }">
    <div class="support-header">
      <div class="header-content">
        <h2 class="title">
          <router-link to="/support-zh" class="link">{{
            $t("m.sedNav.supportTitle")
          }}</router-link>
          <span class="support-text-addon">
            <span class="arrow">&gt;</span>
            <span class="support-current-breadcrumb">{{
              $t("m.sedNav.search")
            }}</span>
          </span>
        </h2>
        <div class="search">
          <span class="support-input">
            <input
              type="text"
              class="support-ipt"
              :placeholder="$t('m.sedNav.search')"
              v-model="search"
              @keydown.enter="submitSearch()"
          /></span>
          <span class="search-icon"> </span>
        </div>
      </div>
    </div>
    <div class="support-content" v-if="!load">
      <article class="support-main">
        <section class="support-list">
          <dt class="search-title" v-html="colorChange(searchtitle)"></dt>
          <div class="support-detail">
            <dl
              v-for="(item, index) in searchRes"
              :key="index"
              class="support-item"
            >
              <dd>
                 <a @click="getTitle(item.title)" v-html="colorChange(item.title)"></a>
                <!-- <router-link
                  class="search-list-title"
                  :to="`/support-zh/` + item.title.replaceAll(` `,`-`).replaceAll(`/`,`&`) + '/'"
                  v-html="colorChange(item.title)"
                ></router-link> -->

                <p
                  class="search-list-detail"
                  v-html="ellipsis(item.describe)"
                ></p>
              </dd>
            </dl>
          </div>
        </section>
      </article>

      <FreqWithBtn></FreqWithBtn>
    </div>
    <div class="loading" v-if="load"></div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import i18n from "../lang";
import FreqWithBtn from "../components/FreqWithBtn.vue";
export default {
  components: { FreqWithBtn },
  setup() {
    return {
      search: useRouter().currentRoute.value.query.search,
    };
  },

  data() {
    return {
      //可视区域高度
      clientHeight: "",
      searchRes: [],
      searchtitle: [],
      article: [],
      Freq: [],
      FreqEn:[],

      load: true,
    };
  },
  created() {
    this.getMod();
    this.freq();
    i18n.global.locale = "zh";
    zE("webWidget", "hide");
  },
  mounted() {
    i18n.global.locale = "zh";
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}` - 104;
    if (this.fullWidth > 767) {
      document.querySelector(".supportLi").style.color = "#fff";
    }
  },
  methods: {
     getTitle(title) {
      var obj = this.$route.params.title;
      axios({
        url: "https://64qx6jnt0a.execute-api.cn-north-1.amazonaws.com.cn/Prod/",
        method: "POST",
        data: {
          methods: "getLangkeys",
          title: title,
        },
      }).then((result) => {
        this.$router.push(
          "/support-zh/" +
            result.data.Items[0].langkeys
              .replaceAll(` `, `-`)
              .replaceAll(`/`, `&`) +
            "/"
        );
      });
    },
    ellipsis(content) {
      let before = content.split("</p>")[0];
      let res = before.split('/">');
      return res[res.length - 1] + " ...";
    },
    async freq() {
      
      await this.$http({
        url: "https://64qx6jnt0a.execute-api.cn-north-1.amazonaws.com.cn/Prod/",
        method: "POST",
        data: {
          methods: "freq",
          lang: "zh",
        },
      }).then((res) => {
        this.Freq = res.data.Items;
      });
    },
    async getMod() {
      await this.$http({
        url: "https://64qx6jnt0a.execute-api.cn-north-1.amazonaws.com.cn/Prod/",
        method: "POST",
        data: {
          methods: "searchArt",
          lang: "zh",
        },
      }).then((res) => {
        res.data.Items.map((item) => {
          this.article.push(item);
        });
        this.submitSearch();
      });
    },
    submitSearch() {
      this.$route.query.search = this.search;
      let searchipt = this.search;
      if (searchipt.length == 0) {
        this.searchRes = this.article;
        this.searchtitle = this.article.length + "Results";
      } else {
        this.searchRes = [];
        this.article.map((item) => {
          if (item.title.toLowerCase().indexOf(searchipt.toLowerCase()) != -1) {
            this.searchRes.push(item);
          }
        });
      }
      if (searchipt.length > 0) {
        if (this.searchRes.length == 0) {
          this.searchtitle = "没有搜索到 " + searchipt + " 相关内容";
        } else {
          this.searchtitle =
            this.searchRes.length + " 个关于 " + searchipt + " 的搜索结果 ";
        }
      } else {
        this.searchtitle = this.searchRes.length + " 个 搜索结果";
      }
      this.load = false;
      this.search = "";
    },
    colorChange(value) {
      //搜索关键词颜色
      let replaceReg = new RegExp(this.$route.query.search, "g");
      let replaceString =
        '<span id="search-text">' + this.$route.query.search + "</span>";
      return value.replace(replaceReg, replaceString);
    },
  },
};
</script>

<style lang="scss" scoped>
//部分样式与support公用

@import "../assets/scss/content.scss";
</style>